"use client";
import { WebVitals } from "@/app/_components/web-vitals";
import { createContext } from "react";
// import "react-toastify/dist/ReactToastify.css";
export const Context = createContext({});

interface Props {
  children: React.ReactNode;
}

const ContextProvider = ({ children }: Props): React.ReactElement<Props> => {
  return (
    <Context.Provider value={{}}>
      <WebVitals />
      {children}
      {/* <ToastContainer pauseOnFocusLoss={false} /> */}
    </Context.Provider>
  );
};

export default ContextProvider;
